export const updateBotResult = (result) => {
    return {
        type: 'UPDATE_TEXT_TO_BOT_RESULT',
        result
    };
};

export const updateTextToVoiceResult = (result) => {
    return {
        type: 'UPDATE_TEXT_TO_VOICE_RESULT',
        result
    };
};

export const clearTextToVoiceResult = () => {
    return {
        type: 'CLEAR_TEXT_TO_VOICE_RESULT',
    };
};

export const clearTextToBotResult = () => {
    return {
        type: 'CLEAR_TEXT_TO_BOT_RESULT',
    };
};

export const clearVoiceToTextResult = () => {
    return {
        type: 'CLEAR_VOICE_TO_TEXT_RESULT',
    };
};

export const updateVoiceToTextResult = (result) => {
    return {
        type: 'UPDATE_VOICE_TO_TEXT_RESULT',
        result
    };
};

export const getLastTextToBot = (lastTextToBot) => {
    return {
        type: 'LOAD_TEXT_TO_BOT_RESULT',
        lastTextToBot,
    };
};

export const updateBotStep = (botStep) => {
    return {
        type: 'UPDATE_BOT_STEP',
        botStep,
    };
};

export const updateLocation = (location) => {
    return {
        type: 'UPDATE_LOCATION',
        location,
    };
};
